export enum FieldClassification {
    Uncategorized = 0,
    FirstParty = 1,
    ThirdParty = 2,
    PrivateThirdParty = 3,
}
